import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import Loading from "../../components/common/Loading";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  GetAttendanceReport,
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getEditReport,
  getGroup,
  GetLateDeduction,
  getPages,
  getProfitCenter,
  getPunchRecords,
  LateDeduct,
  RevertDeduction,
} from "../../services/dataService";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FilterComponent from "../pages/FilterComponent";
import { IconFilter } from "@tabler/icons-react";
import toast from "react-hot-toast";

export default function LateDeduction() {
  const [dates, setDates] = useState({
    FromDate: "",
    ToDate: "",
  });
  const [revertRow, setRevertRow] = useState([]);
  const [rejectRow, setRejectRow] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [data, setData] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deductingRowId, setDeductingRowId] = useState(null);
  const [isDeductingAll, setIsDeductingAll] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmationType, setConfirmationType] = useState(null);
  const [pendingDeduction, setPendingDeduction] = useState(null);
  const [AttendenceReports, setAttendenceReports] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const UID = localStorage.getItem("userId");
  const departmentIds = localStorage.getItem("DepartmentId") || "";
  const DepId = departmentIds.split(",")[0] || null;
  const isAdmin = localStorage.getItem("IsAdmin");
  const UserName = localStorage.getItem("UserName");
  const [editedReport, setEditedReport] = useState([]);
  const [revertModal, setRevertModal] = useState("");
  const [rejectModal, setRejectModal] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterPages, setFilterPages] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [dataFilter, setDataFilter] = useState([]);
  const [PunchRecords, setPunchRecords] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [modalopen, setModalopen] = useState(false);
  const [reason, setReason] = useState("");
  const [lateDetails, setLateDetails] = useState([]);

  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const fetchPunchRecords = async () => {
    const datesr = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
    };
    try {
      setLoading(true);
      const result = await getPunchRecords(datesr);
      setPunchRecords(result.data.data || []);
    } catch (error) {
      console.log("punch rec error", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAttendanceReport = async () => {
    const data = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };

    try {
      setLoading(true);
      const response = await GetLateDeduction(data);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      setAttendenceReports(details);
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    fetchAttendanceReport();
  };

  const handleDeductAll = async () => {
    if (selectedRows.length === 0) {
      toast.error("No rows selected");
      return;
    }

    if (isDeductingAll || deductingRowId) return;

    setConfirmationType("bulk");
    setShowConfirmModal(true);
  };

  const handleDeductAllConfirm = async () => {
    const data = selectedRows.map((row) => ({
      Id: row.Id,
      EmployeeName: row.EmployeeName,
      EmployeeCode: row.EmployeeCode,
      TotalLateThisMonth: row.TotalLateThisMonth,
      DeductionTotal: row.DeductionTotal,
      EmpId: row.EmpId,
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
      UserId: UID,
      DeductionStatus: "1", // Added DeductionStatus for deduct
    }));

    try {
      setLoading(true);
      setIsDeductingAll(true);
      setShowConfirmModal(false);
      const response = await LateDeduct(data);
      toast.success("Bulk deduction processed successfully");
      setSelectedRows([]);
      fetchAttendanceReport();
    } catch (error) {
      console.error("Error processing bulk deduction:", error);
      toast.error("Failed to process bulk deduction");
    } finally {
      setIsDeductingAll(false);
      setLoading(false);
    }
  };

  const handleModalCancel = () => {
    setShowConfirmModal(false);
    setConfirmationType(null);
    setPendingDeduction(null);
  };

  const filteredItems = dataFilter?.filter((item) => {
    return (
      item.EmployeeName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.EmployeeCode?.toString()
        .toLowerCase()
        .includes(filterText.toLowerCase())
    );
  });

  const selectableRows =
    filteredItems?.filter(
      (row) => row.DeductionStatus != 1 && row.DeductionStatus != 3
    ) || [];

  const handleSelectAll = (e) => {
    setSelectedRows(e.target.checked ? selectableRows : []);
  };

  const handleclickView = (row) => {
    let lateDaysData = [];

    if (typeof row.LateDays === "string") {
      try {
        lateDaysData = JSON.parse(row.LateDays);
      } catch (err) {
        console.error("Invalid JSON format in LateDays", err);
        lateDaysData = [];
      }
    } else if (Array.isArray(row.LateDays)) {
      lateDaysData = row.LateDays;
    }

    setLateDetails(lateDaysData);
    setModalopen(true);
  };

  const handleRevertback = (row) => {
    setRevertModal(true);
    setRevertRow(row);
  };

  const handleReject = (row) => {
    setRejectModal(true);
    setRejectRow(row);
  };

  const handleRejectSubmit = async () => {
    if (!rejectRow) {
      toast.error("No row selected for rejection");
      return;
    }

    if (!reason.trim()) {
      toast.error("Please provide a reason for rejection");
      return;
    }

    setLoading(true);
    try {
      const data = {
        Id: rejectRow.Id,
        EmployeeName: rejectRow.EmployeeName,
        EmployeeCode: rejectRow.EmployeeCode,
        DeductionTotal: "0",
        EmpId: rejectRow.EmpId,
        FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
        ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
        UserId: UID,
        DeductionStatus: "3", // Set DeductionStatus to 3 for reject
        Remark: reason, // Include the reason for rejection
      };

      const response = await LateDeduct([data]); // Wrap data in an array if the API expects an array

      if (response.status === 200 || response.status === 201) {
        toast.success("Late deduction rejected");
        setRejectRow(null);
        setRejectModal(false);
        setReason("");
        fetchAttendanceReport();
      } else {
        console.error("Error rejecting deduction", response);
        toast.error("Late deduction cannot be rejected");
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      toast.error("An error occurred while rejecting");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(lateDetails, "useeffect");
  }, [lateDetails]);

  const columnsFilter = [
    {
      name: (
        <input
          type="checkbox"
          checked={
            selectedRows.length === selectableRows.length &&
            selectableRows.length > 0
          }
          onChange={handleSelectAll}
        />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRows.some(
            (selected) => selected.EmpId === row.EmpId
          )}
          disabled={row.DeductionStatus == 1 || row.DeductionStatus == 3||row.ApprovalStatus==1}
          onChange={(e) => {
            setSelectedRows(
              e.target.checked
                ? [...selectedRows, row]
                : selectedRows.filter(
                    (selected) => selected.EmpId !== row.EmpId
                  )
            );
          }}
          style={{
            opacity:
              row.DeductionStatus == 1 || row.DeductionStatus == 3 ? 0.5 : 1,
            cursor:
              row.DeductionStatus == 1 || row.DeductionStatus == 3
                ? "not-allowed"
                : "pointer",
          }}
        />
      ),
      width: "50px",
    },
    {
      name: "Employee Name",
      selector: (row) => row.EmployeeName,
      sortable: true,
    },
    {
      name: "Employee Code",
      selector: (row) => row.EmployeeCode,
      sortable: true,
    },
    {
      name: "Total Late Count",
      selector: (row) => row.TotalLateThisMonth,
      sortable: true,
    },
    {
      name: "Total Deduction Count",
      selector: (row) => row.DeductionTotal,
      sortable: true,
    },
    {
      name: "View LateDetails",
      sortable: true,
      cell: (row) => (
        <button
          onClick={() => handleclickView(row)}
          className="px-2 py-1 bg-blue text-white rounded"
        >
          Click Here
        </button>
      ),
    },
    {
      name: "Status",
      selector: (row) =>
        row.DeductionStatus == 1
          ? "Deducted"
          : row.DeductionStatus == 3
          ? "Rejected"
          : "Not Deducted",
      sortable: true,
    },
    {
      name: "Revert Deduction",
      sortable: true,
      cell: (row) => {
        const isDisabled =
          !row.DeductionStatus ||
          row.DeductionStatus == 0 ||
          row.ApprovalStatus == 1;
        return (
          <button
            disabled={isDisabled}
            onClick={() => handleRevertback(row)}
            className={`px-2 py-1 rounded ${
              isDisabled
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-red-600 text-white hover:bg-blue"
            }`}
          >
            Revert
          </button>
        );
      },
    },
    {
      name: "Reject Deduction",
      sortable: true,
      cell: (row) => {
        const isDisabled =
          row.DeductionStatus == 1 ||
          row.DeductionStatus == 3 ||
          row.ApprovalStatus == 1;
        return (
          <button
            disabled={isDisabled}
            onClick={() => handleReject(row)}
            className={`px-2 py-1 rounded ${
              isDisabled
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-orange-600 text-white hover:bg-orange-700"
            }`}
          >
            Reject
          </button>
        );
      },
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.DeductionStatus == 1,
      style: {
        backgroundColor: "#ffebee",
        color: "#c62828",
      },
    },
    {
      when: (row) => row.DeductionStatus == 3,
      style: {
        backgroundColor: "#fff3e0",
        color: "#e65100",
      },
    },
  ];

  const tableRef = useRef();

 const exportToPDF = () => {

const Filterdata = filteredItems.filter(item => item.DeductionStatus != 3);
    const formatDate = (isoDate) => {
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    };

    const fromDateISO =
      dates.FromDate || new Date().toISOString().split("T")[0];
    const toDateISO = dates.ToDate || new Date().toISOString().split("T")[0];
    const fromDate = formatDate(fromDateISO);
    const toDate = formatDate(toDateISO);

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();

    const tableColumn = [
      "SL",
      "Employee Name",
      "Code",
      "Designation",
      "Section",
      "Total Late Days",
      "Total Deduction",
    ];

    const tableRows = Filterdata?.map((row, index) => [
      index + 1,
      row.EmployeeName || "",
      row.EmployeeCode || "",
      row.DesignationName || "",
      row.ProfitcenterName || "", 
      row.TotalLateThisMonth || 0,
      row.DeductionTotal || 0,
    ]);

    doc.setProperties({
      title: "Late Deduction Report",
      subject: "Late Deduction Report",
      creator: `${companyDetails.Name || "Company"}`,
    });

    const addCenteredTitle = () => {
      // Company Name (Main Title)
      const title = `${companyDetails?.Name?.toUpperCase() || "COMPANY"}`;
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      const titleWidth = doc.getTextWidth(title);
      const titleXPos = (pageWidth - titleWidth) / 2;
      doc.text(title, titleXPos, 15);

      // Report Header (Sub Title)
      const headerText = `LATE DEDUCTION REPORT`;
      doc.setFontSize(12);
      const headerWidth = doc.getTextWidth(headerText);
      const headerXPos = (pageWidth - headerWidth) / 2;
      doc.text(headerText, headerXPos, 25);

      // Date Range
      const dateText = `From: ${fromDate} To: ${toDate}`;
      doc.setFontSize(10);
      const dateWidth = doc.getTextWidth(dateText);
      const dateXPos = (pageWidth - dateWidth) / 2;
      doc.text(dateText, dateXPos, 35);

      return 45; // Return Y position for table start
    };

    let currentY = addCenteredTitle();

    doc.autoTable({
      startY: currentY,
      head: [tableColumn],
      body: tableRows,
      styles: {
        fontSize: 11,
        cellPadding: 2,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        fontStyle: "bold",
      },
      margin: { top: 20, right: 14, bottom: 20, left: 14 },
      tableLineWidth: 0.5,
      tableLineColor: [0, 0, 0],
    });

    currentY = doc.previousAutoTable.finalY + 8;

    if (currentY > doc.internal.pageSize.height - 40) {
      doc.addPage();
      currentY = 20;
    }

    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Signature:", 14, currentY);
    currentY += 5;
    doc.setLineWidth(0.2);
    doc.line(14, currentY, 64, currentY);

    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString("en-GB")}`;
    const generatedBy = `Generated by: ${UserName}`;
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    const textWidth = doc.getTextWidth(generatedText);
    const marginRight = 14;
    const lineSpacing = 4;

    doc.text(
      generatedText,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20
    );
    doc.text(
      generatedBy,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20 + lineSpacing
    );

    doc.setPage(1);
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Page 1`,
      doc.internal.pageSize.width - 25,
      doc.internal.pageSize.height - 10
    );

    doc.save(`Late_Deduction_Report_${fromDate}_to_${toDate}.pdf`);
  };
  useEffect(() => {
    if (AttendenceReports && AttendenceReports.length > 0) {
      setDataFilter(AttendenceReports);
    } else {
      setDataFilter([]);
    }
  }, [AttendenceReports]);

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  useEffect(() => {
    const fetchfilterPage = async () => {
      try {
        const response = await getPages(UID);
        const filteredPages = response.data.data.filter((page) =>
          [
            "Category",
            "Profit Center",
            "Group",
            "Designation",
            "Department",
          ].includes(page.Name)
        );
        setFilterPages(filteredPages);
      } catch (error) {
        console.error("Error fetching pages:", error);
      }
    };
    fetchfilterPage();
  }, []);

  const [category, setCategory] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [group, setGroup] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategory();
  }, []);

  useEffect(() => {
    const fetchDesignation = async () => {
      try {
        const response = await getDesignation(UID);
        setDesignation(response);
      } catch (error) {
        console.error("Error fetching designations:", error);
      }
    };
    fetchDesignation();
  }, []);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);
        setGroup(response);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    fetchGroup();
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);
        setDepartment(response);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchProfitCenter = async () => {
      try {
        const response = await getProfitCenter(UID);
        setFilterProfitcenter(response);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchProfitCenter();
  }, []);

  useEffect(() => {
    const uniqueShifts = Array.from(
      new Map(filteredItems.map((item) => [item.ShiftId, item])).values()
    );
    const shiftOptions = uniqueShifts.map((el) => ({
      Id: el.ShiftId,
      Name: el.ShiftName,
    }));

    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;
      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department?.data?.data);
        break;
      case "ShiftId":
        setDropdownOptions(shiftOptions);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

const handleFilterChange = async (selectedMethod, Name, Id) => {
  setFilterMethod(selectedMethod);

  try {
    setLoading(true);
    let filteredData = AttendenceReports;

    // Apply filter based on the selected method and ID
    if (selectedMethod && Id) {
      filteredData = AttendenceReports.filter((item) => {
        switch (selectedMethod) {
          case "CategoryId":
            return item.CategoryId == Id;
          case "ProfitCenterID":
            return item.ProfitCenterId == Id;
          case "GroupId":
            return item.GroupId == Id;
          case "DesignationId":
            return item.DesignationId == Id;
          case "DepartmentID":
            return item.DepartmentId == Id;
          default:
            return true; // No filter applied if method is unrecognized
        }
      });
    }

    // Update the dataFilter state with filtered results
    setDataFilter(filteredData);
  } catch (error) {
    console.error("Error filtering data", error);
    toast.error("An error occurred while filtering data");
  } finally {
    setLoading(false);
  }
};
  const handleMonthChange = (e) => {
    const selectedMonthValue = e.target.value;
    setSelectedMonth(selectedMonthValue);

    const [year, month] = selectedMonthValue?.split("-").map(Number);
    const firstDay = `${selectedMonthValue}-01`;
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    const lastDay = `${selectedMonthValue}-${String(lastDayOfMonth).padStart(
      2,
      "0"
    )}`;

    setDates({
      FromDate: firstDay,
      ToDate: lastDay,
    });
  };

  const handleRevertSubmit = async (revertRow) => {
    console.log(revertRow,'sdsdsd');
    
    setLoading(true);
    try {
      const data = {
        Id: revertRow.LateDeductionId,
        UserId: UID,
        Remark: reason,
      };

      const response = await RevertDeduction(data);

      if (response.status === 200 || response.status === 201) {
        toast.success("Late deduction Reverted");
        setRevertRow(null);
        setRevertModal(false);
        setReason("");
        fetchAttendanceReport();
      } else {
        console.error("Error reverting deduction", response);
        toast.error("Late deduction cannot be reverted");
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      toast.error("An error occurred while reverting");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {modalopen && (
        <div className="fixed inset-0 flex justify-center items-center bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="bg-white rounded-lg shadow-xl w-[800px] max-h-[600px] flex flex-col">
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-xl font-semibold text-gray-800">
                Late Details
              </h2>
              <button
                className="text-gray-400 hover:text-gray-600 text-2xl"
                onClick={() => setModalopen(false)}
              >
                ×
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-6">
              <div className="space-y-4">
                {lateDetails.length > 0 ? (
                  lateDetails.map((el, index) => (
                    <div
                      key={index}
                      className="border border-gray-200 rounded-lg p-4 bg-gray-50"
                    >
                      <div className="flex justify-between items-center mb-3">
                        <div>
                          <h3 className="font-semibold text-gray-800">
                            {el.ShiftName}
                          </h3>
                          <p className="text-sm text-gray-600">
                            Date: {el.Recorddate}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-600">Late Time</p>
                          <p className="font-bold text-red-600">
                            {el.LateTime}
                          </p>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <p className="text-gray-600">
                            Shift Start Time:{" "}
                            <span className="font-medium text-gray-800">
                              {el.ShiftStartTime}
                            </span>
                          </p>
                          <p className="text-gray-600">
                            Grace Period:{" "}
                            <span className="font-medium text-gray-800">
                              {el.GracePeriod} minutes
                            </span>
                          </p>
                          <p className="text-gray-600 mt-1">
                            Shift End Time:{" "}
                            <span className="font-medium text-gray-800">
                              {el.ShiftEndTime}
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="text-gray-600">
                            Punch In:{" "}
                            <span className="font-medium text-gray-800">
                              {el.Punchin}
                            </span>
                          </p>
                          <p className="text-gray-600 mt-1">
                            Punch Out:
                            {el.Punchout ? (
                              <span className="font-medium text-gray-800">
                                {" "}
                                {el.Punchout}
                              </span>
                            ) : (
                              <span className="text-orange-600 font-medium">
                                {" "}
                                Not Punched Out
                              </span>
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-gray-500 py-8">
                    No Late Records Found
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-end p-6 border-t bg-gray-50">
              <button
                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                onClick={() => setModalopen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {revertModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="bg-white rounded-lg shadow-xl w-[800px] max-h-[600px] flex flex-col">
            <div className="p-6">
              <label htmlFor="revert-reason">
                Enter Reason <span className="text-red-600">*</span>
              </label>
              <textarea
                id="revert-reason"
                required
                onChange={(e) => setReason(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg"
              />
            </div>
            <div className="flex justify-end p-6 border-t bg-gray-50">
              <button
                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                onClick={() => setRevertModal(false)}
              >
                Close
              </button>
              <button
                className="px-6 ms-2 py-2 bg-blue text-white rounded-lg hover:bg-blue-600 transition"
                onClick={()=>handleRevertSubmit(revertRow)}
              >
                {loading ? "Processing" : "Revert"}
              </button>
            </div>
          </div>
        </div>
      )}
      {rejectModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="bg-white rounded-lg shadow-xl w-[800px] max-h-[600px] flex flex-col">
            <div className="p-6">
              <label htmlFor="reject-reason">
                Enter Reason for Rejection{" "}
                <span className="text-red-600">*</span>
              </label>
              <textarea
                id="reject-reason"
                required
                onChange={(e) => setReason(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg"
              />
            </div>
            <div className="flex justify-end p-6 border-t bg-gray-50">
              <button
                className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                onClick={() => {
                  setRejectModal(false);
                  setReason("");
                }}
              >
                Cancel
              </button>
              <button
                className="px-6 ms-2 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition"
                onClick={() => handleRejectSubmit()}
              >
                {loading ? "Processing" : "Reject"}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col md:flex-row items-center justify-between mb-8">
        <div className="flex flex-col md:flex-row gap-4 md:gap-[40px] w-full mb-4 md:mb-0">
          <Breadcrumb title="LateDeduction" />
          <b className="text-xl">
            Total Employees:{" "}
            {AttendenceReports?.length ? AttendenceReports?.length : 0}
          </b>
        </div>
        {AttendenceReports?.length ? (
          <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
            <div className="flex flex-col md:flex-row items-center gap-2 p-5 bg-gray-100 rounded w-full md:w-auto">
              <button
                className="bg-sky-500 rounded-[4px] px-10 py-[8px]"
                onClick={handleFilterClick}
              >
                <IconFilter className="text-white w-[18px] h-[18px]" />
              </button>
              <div className="relative w-full md:w-[400px]">
                <input
                  type="text"
                  id="search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Search by Emp Name/Code"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <button
                onClick={handleClear}
                className="btn btn-danger w-full md:w-auto mt-2 md:mt-0"
              >
                Clear
              </button>
            </div>
            <div className="flex flex-row gap-4 w-full md:w-auto justify-center md:justify-start">
              <button
                onClick={exportToPDF}
                className="btn btn-danger w-full md:w-auto"
              >
                PDF
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={AttendenceReports}
          onFilter={handleFilter}
        />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="flex items-center p-4">
          <label
            htmlFor="month-input"
            className="text-sm font-medium text-gray-700 mr-2"
          >
            Select Month
          </label>
          <input
            type="month"
            name="selectedMonth"
            onChange={handleMonthChange}
            value={selectedMonth}
            id="month-input"
            className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
          />
          <button className="btn btn-success ml-4" onClick={handleClick}>
            Show
          </button>
          <select
            id="filter-method"
            name="filter-method"
            className="ml-4 w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
            value={filterMethod}
            onChange={(e) => setFilterMethod(e.target.value)}
          >
            <option value="">Filter By</option>
            <option value="CategoryId">Category</option>
            <option value="ProfitCenterID">Profit Center</option>
            <option value="GroupId">Group</option>
            <option value="DesignationId">Designation</option>
            <option value="DepartmentID">Department</option>
          </select>
          <select
  id="dynamic-options"
  name="dynamic-options"
  className="ml-4 w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
  onChange={(e) => {
    const selectedOption = dropdownOptions.find(
      (option) => option.Id.toString() === e.target.value
    );
    if (selectedOption) {
      handleFilterChange(filterMethod, selectedOption.Name, selectedOption.Id);
    } else {
      // If no option is selected, reset to original data
      handleFilterChange("", "", "");
    }
  }}
>
  <option value="" selected>
    Choose One
  </option>
  {dropdownOptions?.length > 0 &&
    dropdownOptions.map((option) => (
      <option key={option.Id} value={option.Id}>
        {option.Name}
      </option>
    ))}
</select>
          <button
            onClick={handleDeductAll}
            disabled={
              selectedRows.length === 0 || isDeductingAll || deductingRowId
            }
            className={`px-4 ms-2 py-2 rounded text-white flex items-center gap-2 w-full md:w-auto ${
              selectedRows.length === 0 || isDeductingAll || deductingRowId
                ? "bg-red-300 cursor-not-allowed"
                : "bg-red-500 hover:bg-red-600"
            }`}
          >
            {isDeductingAll ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Processing...
              </>
            ) : (
              `Deduct All (${selectedRows.length})`
            )}
          </button>
        </div>
        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <div ref={tableRef}>
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems.length ? filteredItems : []}
                pagination
                responsive
                conditionalRowStyles={conditionalRowStyles}
              />
            </div>
          )}
        </div>
      </div>
      {showConfirmModal && (
        <div className="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L5.232 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">
              Confirm Deduction
            </h3>
            <p className="text-gray-600 text-center mb-6">
              This deduction will be applied by cutting the employee's casual
              leave. If no casual leave is available, it will be marked as LOP
              (Loss of Pay).
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={handleModalCancel}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDeductAllConfirm}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
              >
                {loading ? "Processing" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
